export function idpIELTSEnabled(universityId) {
    if (process.env.APP_ENV === 'staging')
        return universityId === 104759;
    return universityId === 1951 || universityId === 1576;
}
